import React from "react";
import { Link } from "react-router-dom";

import ARTICLE_CONFIG from "../../data/articleConfig";
import { track } from "../../lib/analytics";

import "./styles/ctaBlock.css";

const CTABlock = () => {
	const kitAction = `https://app.kit.com/forms/${ARTICLE_CONFIG.kitFormId}/subscriptions`;

	return (
		<div className="cta-block">
			<div className="cta-block-card">
				<div className="cta-block-heading">Get the next one</div>
				<div className="cta-block-text">
					{ARTICLE_CONFIG.newsletterPitch}
				</div>
				<form
					className="cta-block-form"
					action={kitAction}
					method="post"
					target="popupwindow"
					onSubmit={() => {
						track("newsletter-subscribe");
						window.open(
							"about:blank",
							"popupwindow",
							"width=480,height=640"
						);
					}}
				>
					<input
						className="cta-block-input"
						type="email"
						name="email_address"
						placeholder="you@company.com"
						aria-label="Email address"
						required
					/>
					<button className="cta-block-button" type="submit">
						Subscribe
					</button>
				</form>
			</div>

			<div className="cta-block-speaking">
				{ARTICLE_CONFIG.speakingPitch}{" "}
				<Link
					to={ARTICLE_CONFIG.speakingLink}
					className="cta-block-speaking-link"
				>
					Invite me to speak →
				</Link>
			</div>
		</div>
	);
};

export default CTABlock;
